import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { FormasPagamentoWrapper } from '../persistences/formas-pagamento-wrapper';

@Injectable({
  providedIn: 'root'
})
export class FormaCondService {

  constructor(private configService: ConfigService,
		private httpClient: HttpClient) { }

  getFormaCondPgto(cdCliente: number): Observable<FormasPagamentoWrapper> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('cdCliente', cdCliente.toString())
		return this.httpClient.get<FormasPagamentoWrapper>(
			this.configService.getEndereco() + '/FormaCondPgto/ValidasWebByCliente',
			{
				headers: this.configService.getHeaders(),
				params: httpParams
			}
		)
	}
}
